/**
 * Contains the type and supporting data for the various potential states of the right sidebar.
 * Uses a discriminated union to allow the RightSidebar component to switch over the types and pass
 * the rest of the params to the appropriate component.
 */

import { z } from "zod";
// Ideally we'd define these next to their components, but it because they depend on the
// hooks and the hooks depend on the schema, circular dependencies are a problem.
// We'd need to define these in their own files next to their components, and be very careful about imports.
// This is less error prone and works for now.

const contactListSchema = z.object({
  type: z.literal("contactList"),
  contactId: z.string().optional(),
  searchQuery: z.string().optional(),
  // Which contact-detail tab to open on (People-view clicks pass "bio").
  defaultTab: z.enum(["communications", "events", "bio"]).optional(),
});
export type ContactListSchema = z.infer<typeof contactListSchema>;

const communicationSidebarSchema = z.object({
  type: z.literal("communication"),
  /** Source ent id of the communication (email or text/SMS) to display. */
  id: z.string(),
});
export type CommunicationSidebarSchema = z.infer<typeof communicationSidebarSchema>;

const communicationThreadSidebarSchema = z.object({
  type: z.literal("communicationThread"),
  /** Source ent id of any message in the conversation; the server expands it to
   *  the full thread. */
  communicationId: z.string(),
});
export type CommunicationThreadSidebarSchema = z.infer<typeof communicationThreadSidebarSchema>;

export const sidebarSchema = z.discriminatedUnion("type", [
  contactListSchema,
  communicationSidebarSchema,
  communicationThreadSidebarSchema,
]);
export type SidebarSchema = z.infer<typeof sidebarSchema>;
